import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Title } from "@vds/typography";
import { Line } from "@vds/lines";
import { ModalBody } from "@vds/modals";
import styled from "styled-components";
import BackPath from "../../assets/icons/Back-Path.svg";
import {
  ModalBox,
  CustomisedBackPath,
  Wrapper,
  CustomisedTitle,
  FlexColumn,
  FlexRow,
  CustomisedTertiaryButton,
  CPButton,
  TextWrapper,
} from "../../constants/common/StyledGlobalConstants";
import { Stepper, Step, StepTitle, useStepper } from "react-progress-stepper";
import {
  resetAppointmentDetails,
  setServiceTotalFee,
  setSelectedSlotDetails,
  setReschedule,
  createReschedule,
  setServiceDetails,
  setUpdateJob,
  updateJobCall,
  createScheduleCall,
  setIsValidateAddress,
  fetchAccountDetails,
  setJobDurationDetails,
  createNewCaseCall,
  closeCaseAndJobCall,
  setCreateCaseAPIFailure,
  fetchRescheduleReasonList,
  setRescheduleAppointmentDetails,
  fetchRevealVehicles,
  updateCaseOnSchedule,
  setAPIFailure,
  updateCaseOnAPIFailureRescheduleCall,
  setJobDurationExceeds10Hrs,
  setCurrentPage,
} from "../../store/actions/schedulingportal/technicianAppointment";
import "./TechnicianAppointmentsModal.css";
import ContactDetailsModal from "./ContactDetails/ContactDetailsModal";
import BookingConfirmed from "./BookingConfirmed";
import RequestOverview from "./RequestOverviewPage/RequestOverview";
import Footer from "./common/Footer";
import { Loader } from "@vds/loaders";
import DiscardChangesModal from "./common/DiscardChangesModal";
import VehicleAssetDetailsHeader from "./VehicleorAssetDetails/VehicleAssetDetailsHeader";
import AppointmentDateAndTime from "./AppointmentTimePage/AppointmentDateAndTime";
import RescheduleReason from "./RequestOverviewPage/RescheduleReason";
import { commercialAccountsJobDurationDetails } from "./JobDurationDetails";
import { servicesArray } from "./common/JobsPayload";
import RedesignedModal from "../common/RedesignedModal";
import DeleteServiceModal from "./VehicleorAssetDetails/DeleteServiceModal";
import RequestOverviewOnVinCompatibilityIssue from "./ContactDetails/RequestOverviewOnVinCompatibilityIssue";
import RequestSubmitted from "./RequestSubmitted";
import { DEFAULT_REASON } from "../../constants/technicianAppointmentConstants";
import EmptylistNotification from "../billingPayment/EmptylistNotification";
import SomethingWentWrongTryAgain from "./SomethingWentWrongTryAgain";
import { findCurrentPage, getPendoId } from "../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import AppointmentTimeUnavailable from "./RequestOverviewPage/AppointmentTimeUnavailable";
import PropTypes from "prop-types";
const { TABLET } = DEVICE_BREAKPOINTS;

const StepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  border: none;
  outline: none;
  height: 3.125rem;
  align-items: flex-start;
  @media (min-width: 360px) and (max-width: 1023px) {
    margin-bottom: 0;
    padding-left: 0;
    height: 4.125rem;
    margin-top: 1.5rem;
  }
  :focus-visible {
    outline: none;
  }
`;
const SubWrapper = styled.div`
  width: 632px;
  @media (max-width: 1023px) {
    width: 100%;
  }
`;
const StepperCount = styled.div`
  color: #6f7171;
  font-family: "neue-haas-grotesk-text";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: none;
  @media (max-width: 1023px) {
    display: block;
  }
`;
const StepperTitle = styled.div`
  color: #000;
  font-family: "neue-haas-grotesk-text";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-top: 3px;
  margin-bottom: 10px;
  display: none;
  letter-spacing: 0;
  @media (max-width: 1023px) {
    display: block;
  }
`;

const ModalHeaderCloseButton = styled(Wrapper)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 24px 0;
  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 16px 0;
  }
  @media (max-width: 767px) {
    width: 77%;
  }
  @media (max-width: 400px) {
    width: 70.8%;
  }
`;

const CustomModalBody = styled(ModalBody)`
  // padding: 0;
  @media (max-width: 679px) {
    // padding: 0 1rem;
  }
  // margin-bottom: 3rem;
  // min-height: calc(100vh-70px);
  // padding-bottom: 100px;
`;

const CFSTCustomisedTitle = styled(CustomisedTitle)`
  font-size: 24px;
  line-height: 32px;
  margin: 0px;
  @media (max-width: 1023px) {
    width: 65%;
  }
`;

const CFSTFlexColumn = styled(FlexColumn)`
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0px 16px;
  }
`;

const CFSTFlexRow = styled(FlexRow)`
  @media (max-width: 1023px) {
    padding: 0px 16px 0px 16px;
  }
  @media (max-width: 960px) {
    margin: 2.5rem auto 9rem auto;
  }
  @media (min-width: 961px) and (max-width: 1023px) {
    margin: 2.5rem auto 5rem auto;
  }
  @media (min-width: 1024px) {
    width: 57.223%;
    margin: 3rem auto 2rem auto;
  }
  @media (min-width: 1920px) {
    width: 43.223%;
  }
`;

function getIsNextDisabled(serviceDetails) {
  if (!serviceDetails.length) return true;
  return !serviceDetails.every((service) => !service.isError);
}

function getIsAdditionalService(serviceDetails) {
  return !!serviceDetails.length;
}

const TechnicianAppointmentModal = ({ serviceType, ...props }) => {
  const { step, incrementStep, decrementStep } = useStepper(1, 5);
  const {
    loading,
    serviceDetails,
    accountDetails,
    materialList,
    jobDurationDetails,
    jobResponseData,
    caseSfdcId,
    isReschedule,
    jobDetails,
    isAssistanceRequired,
    isCreateCaseAPIFailed,
    rescheduleReasons,
    rescheduleAppointmentDetails,
    vehicleAndAssetList: { error: vehicleAndAssetListAPIError },
    APIFailure,
    isScheduleApiFailed,
    caseNumber,
    agentAssistanceCaseDetails,
    preferredDate,
    isJobScheduleDateIsWithInThreeBusinessDays,
    isJobDurationExceeds10Hrs,
    estAppointmentLength,
    isUpdateCaseApiFailed,
  } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  const { account_id, windowSize, regionId, vztSegment, brands, isSourcewellGovernment } = useSelector((state) => state.ACCOUNT);
  const [isNextDisabled, setIsNextDisabled] = useState(getIsNextDisabled(serviceDetails));
  const [isAdditionalService, setIsAdditionalService] = useState(getIsAdditionalService(serviceDetails));
  const [isDiscardChange, setIsDiscardChange] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slotDetails, setSlotDetails] = useState(null);
  const [isGoBackModalOpen, setIsGoBackModalOpen] = useState(false);
  const [isFirstServiceEdited, setIsFirstServiceEdited] = useState(false);
  const [isApptAlreadyTaken, setIsApptAlreadyTaken] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stepperRef = useRef();
  const { preferredSelectedDate } = useSelector((state) => state.ACCOUNT);

  const schedulingNotesAndUpdateCaseCall = () => {
    isScheduleApiFailed || APIFailure.isSlotsFailure || APIFailure.isTransactionFailure || isJobScheduleDateIsWithInThreeBusinessDays || step === 3
      ? navigate(`/account/technicianAppointments`)
      : navigate(`/account/technicianAppointments/viewAppointmentDetails/${jobDetails.id}`);
    dispatch(setServiceTotalFee(0));
    dispatch(resetAppointmentDetails());
  };

  const handleFooterCancel = () => {
    if (isReschedule) {
      props.setIsOpen(false);
      //Navigate user to Appointment details page when cancelled
      //If Reschedule API fails take user to landing page
      if (isUpdateCaseApiFailed) {
        dispatch(updateCaseOnAPIFailureRescheduleCall(schedulingNotesAndUpdateCaseCall));
      } else {
        schedulingNotesAndUpdateCaseCall();
      }
    } else if (
      step !== 5 &&
      (caseSfdcId || jobResponseData?.id) &&
      !APIFailure.isJobFailure &&
      !APIFailure.isSlotsFailure &&
      !APIFailure.isTransactionFailure &&
      !isJobDurationExceeds10Hrs
    ) {
      dispatch(
        closeCaseAndJobCall(() => {
          props.setIsOpen(false);
          dispatch(setServiceTotalFee(0));
          navigate("/account/technicianAppointments");
          dispatch(resetAppointmentDetails());
        })
      );
    } else if (isUpdateCaseApiFailed) {
      dispatch(updateCaseOnSchedule());
    }
    props.setIsOpen(false);
    dispatch(setServiceTotalFee(0));
    dispatch(setAPIFailure({ isJobFailure: false, error: "", isSlotsFailure: false, isTransactionFailure: false }));
    dispatch(resetAppointmentDetails());
    dispatch(setJobDurationExceeds10Hrs(false));
    dispatch(setCreateCaseAPIFailure(null)); // cancel button resetting the create case failure state on discard
    navigate("/account/technicianAppointments");
  };

  useEffect(() => {
    const {
      data: { salesOrg },
    } = accountDetails;
    if (!salesOrg) {
      dispatch(fetchAccountDetails(account_id));
    } else if (!isReschedule && (vehicleAndAssetListAPIError || vehicleAndAssetListAPIError === null)) {
      dispatch(fetchRevealVehicles());
    }
    if (isCreateCaseAPIFailed) dispatch(setCreateCaseAPIFailure(null));
  }, []);

  useEffect(() => {
    if ((!isReschedule && step === 2 && APIFailure.isJobFailure) || (step === 3 && (APIFailure.isSlotsFailure || APIFailure.isTransactionFailure))) {
      dispatch(updateCaseOnSchedule());
    }
    if (isReschedule && step === 1 && (APIFailure.isSlotsFailure || APIFailure.isTransactionFailure)) {
      dispatch(updateCaseOnAPIFailureRescheduleCall());
    }
  }, [APIFailure, step, isReschedule]);

  useEffect(() => {
    const currentPage = findCurrentPage(step, currentIndex, isReschedule, isAssistanceRequired, isJobDurationExceeds10Hrs, isScheduleApiFailed);
    dispatch(setCurrentPage(currentPage));
  }, [step, currentIndex, isReschedule, isAssistanceRequired, isJobDurationExceeds10Hrs, isScheduleApiFailed]);

  useEffect(() => {
    if (windowSize.width > TABLET) {
      const htmlElement = document.querySelector("html");
      // Update properties dynamically
      if (htmlElement) {
        htmlElement.style.overflow = "hidden"; // Disable scrolling
      }
      // Cleanup function to reset properties when component unmounts
      return () => {
        if (htmlElement) {
          htmlElement.style.overflow = ""; // Reset overflow
        }
      };
    }
  }, [windowSize]);

  // Function to show the discard change modal if the form has value
  // else it will close the technician appointment modal
  const handleFooterCancelValidate = () => {
    if (isReschedule) {
      handleRescheduleCancel();
    } else {
      handleRegularCancel();
    }
  };

  const handleRescheduleCancel = () => {
    if (step === 3) {
      closeModalAndReset();
    }
    // Show Discard modal if any date is selected
    preferredDate ? setIsDiscardChange(true) : handleFooterCancel();
  };

  const handleRegularCancel = () => {
    if (step === 5) {
      closeModalAndReset();
    } else if (shouldShowDiscardModal()) {
      setIsDiscardChange(true); // Show discard modal when services are already added
    } else {
      handleFirstServiceDiscard();
    }
  };

  const closeModalAndReset = () => {
    props.setIsOpen(false);
    dispatch(setServiceTotalFee(0));
    navigate("/account/technicianAppointments");
    dispatch(resetAppointmentDetails());
  };

  const shouldShowDiscardModal = () => {
    return serviceDetails.length && !(step === 4 && isJobDurationExceeds10Hrs);
  };

  const handleFirstServiceDiscard = () => {
    // If the first service is not saved and the fields are not empty, show the discard modal
    // If the first service is not saved and the fields are empty, don't show the discard modal
    isFirstServiceEdited && !isJobDurationExceeds10Hrs ? setIsDiscardChange(true) : handleFooterCancel();
  };

  //This function will close the discard change modal and stay in technician appointment modal if user click cancel,
  //if user clicks discard button it will close both technician appointment modal and discard change modal
  const handleDiscardChangeModal = (discard) => {
    setIsDiscardChange(false);
    dispatch(setCreateCaseAPIFailure(null)); // cancel button resetting the create case failure state on cancelling
    if (discard === "discard") {
      handleFooterCancel();
    }
  };

  const mapServiceDetailsFields = (data) => {
    let transferCount = 1;
    let removalCount = 1;
    data.forEach((item, index) => {
      if (item.serviceType === "Transfer") {
        serviceDetails[index].uiIndex = `Transfer${transferCount}`;
        transferCount++;
      }
      if (item.serviceType === "Removal") {
        serviceDetails[index].uiIndex = `Removal${removalCount}`;
        removalCount++;
      }
    });
    dispatch(setServiceDetails(data));
  };

  function handleRescheduleStep(type) {
    if (step > 2) {
      dispatch(setReschedule(false));
      props.setIsOpen(false);
      return;
    }

    if (type === "next") {
      handleRescheduleNext();
    } else if (type === "back") {
      handleRescheduleBack();
    }
  }

  function handleRescheduleNext() {
    if (step === 1 && currentIndex === 0) {
      dispatch(setSelectedSlotDetails(slotDetails));
      if (!rescheduleReasons?.reasons?.length) {
        dispatch(fetchRescheduleReasonList(handleRescheduleReasonsApiCallback));
      } else {
        handleRescheduleReasonsApiCallback({ apiFailed: false });
      }
    }
    if (step === 1 && currentIndex === 1) incrementStep();
    if (step === 2) dispatch(createReschedule(scheduleCallBack));
  }

  function handleRescheduleBack() {
    if (step === 1 && currentIndex === 1) {
      setIsGoBackModalOpen(true);
    } else if (rescheduleAppointmentDetails?.isDefaultReasonSelected) {
      setIsGoBackModalOpen(true);
    } else {
      decrementStep();
    }
  }

  function handleNonRescheduleStep(type) {
    if (step > 4) {
      props.setIsOpen(false);
      return;
    }

    if (type === "next") handleNonRescheduleNext();
    if (type === "back") handleNonRescheduleBack();
    if (type === "submit") handleNonRescheduleSubmit(type);

    // Common navigation logic
    if (type === "back") setIsAdditionalService(true);
    if (type === "next" && step < 4 && step !== 2) incrementStep();
    if (type !== "next" && type === "back" && step !== 3 && step !== 4) decrementStep();
    if (type === "back") {
      if (step === 3 && (isJobDurationExceeds10Hrs || isAssistanceRequired || preferredSelectedDate === null)) {
        decrementStep();
      } else if ((step === 3 && preferredSelectedDate !== null) || step === 4) {
        setIsGoBackModalOpen(true);
      }
    }
  }

  function handleNonRescheduleNext() {
    if (step === 1) {
      handleStepOne();
    }
    if (step === 2) {
      handleStepTwo();
    }
    if (step === 3) {
      dispatch(setSelectedSlotDetails(slotDetails));
    }
    if (step === 4) {
      dispatch(createScheduleCall(scheduleCallBack));
    }
  }

  function handleStepOne() {
    if (jobResponseData?.id === undefined) mapServiceDetailsFields(serviceDetails);
    let totalDuration = commercialAccountsJobDurationDetails(serviceDetails, materialList, jobResponseData, vztSegment, brands);
    servicesArray(serviceDetails);
    if (isJobDurationExceeds10Hrs) {
      totalDuration != null && totalDuration / 60 > 10 ? dispatch(setJobDurationExceeds10Hrs(true)) : dispatch(setJobDurationExceeds10Hrs(false));
    }
  }

  function handleStepTwo() {
    const exceeds10Hrs = estAppointmentLength != null && estAppointmentLength / 60 > 10;
    dispatch(setJobDurationExceeds10Hrs(exceeds10Hrs));
    if (!exceeds10Hrs && !isAssistanceRequired) {
      if (jobResponseData?.id !== undefined) {
        dispatch(updateJobCall(incrementStep));
      } else {
        dispatch(createNewCaseCall(incrementStep));
      }
    } else {
      incrementStep();
    }
  }

  function handleNonRescheduleBack() {
    if (step === 2) {
      dispatch(setCreateCaseAPIFailure(null));
      setIsNextDisabled(false);
    }
    if (step === 3) {
      if (jobResponseData?.id) {
        dispatch(setUpdateJob({ payload: jobResponseData, isUpdated: false }));
        let data = jobDurationDetails;
        jobResponseData?.jobDurationDetails.forEach((item, index) => {
          data[index].id = item.id;
        });
        dispatch(setJobDurationDetails(data));
      }
    }
  }

  function handleNonRescheduleSubmit(type) {
    if (step === 3 && (isAssistanceRequired || isJobDurationExceeds10Hrs)) {
      dispatch(createNewCaseCall(incrementStep));
    }
  }

  const handleStepNavigate = (type) => {
    const startOfModalBlock = document.getElementById("full-screen-modal-cfst");
    startOfModalBlock?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (step !== 2 || isCreateCaseAPIFailed) {
      stepperRef?.current?.focus();
    }
    if (isReschedule) {
      handleRescheduleStep(type);
    } else {
      handleNonRescheduleStep(type);
    }
    if (step === 2 && type === "next") {
      dispatch(setIsValidateAddress(false));
    }
  };

  const scheduleCallBack = (isApptTaken = false) => {
    if (isApptTaken) {
      setIsApptAlreadyTaken(true);
    } else {
      incrementStep();
    }
  };

  const reTriggerCreateCaseAPI = () => {
    dispatch(createNewCaseCall(incrementStep));
  };

  //Call derecharge api when user clicks on the transfer/remove device buttons
  // useEffect(() => {
  //   dispatch(fetchFee());
  // }, []);

  const handleRescheduleReasonsApiCallback = (data) => {
    const { apiFailed = false } = data;
    if (apiFailed) {
      //Set the default Reschedule reason
      let appointmentDetails = {
        ...rescheduleAppointmentDetails,
        ...DEFAULT_REASON,
        isDefaultReasonSelected: true,
      };
      dispatch(setRescheduleAppointmentDetails(appointmentDetails));
      //skip, reschedule reasons step and jump to Request overview step
      incrementStep();
    } else {
      setCurrentIndex(1);
    }
  };

  function handleGoBackAction(isReschedule, rescheduleAppointmentDetails, decrementStep, setCurrentIndex) {
    if (isReschedule) {
      if (rescheduleAppointmentDetails?.isDefaultReasonSelected) {
        decrementStep();
      } else {
        setCurrentIndex(0);
      }
    } else {
      decrementStep();
    }
  }

  const handleGoBack = () => {
    setIsGoBackModalOpen(false);
    handleGoBackAction(isReschedule, rescheduleAppointmentDetails, decrementStep, setCurrentIndex);
  };

  useEffect(() => {
    if (isReschedule === true && accountDetails?.error === true) {
      setIsNextDisabled(true);
    } else if (isReschedule === true && !accountDetails?.error) {
      setIsNextDisabled(false);
    }
  }, [accountDetails?.error]);

  function getAppointmentTitle(isReschedule, jobDetails) {
    if (isReschedule && jobDetails?.id) {
      return {
        id: `appointment-title-${jobDetails.id}`,
        text: `Appointment ${jobDetails.id}`,
      };
    }
    return {
      id: "technician-appointment-title",
      text: "Technician appointments",
    };
  }

  function getWrapperPaddingBottom(windowSize) {
    return windowSize.width < TABLET ? "130px" : "auto";
  }

  function getRescheduleRowPadding(regionId) {
    return regionId === "840" || regionId === "124" ? "2.5rem" : "0px !important";
  }

  function renderRescheduleStepOneContent({ step, currentIndex, APIFailure, windowSize, setIsNextDisabled, setSlotDetails }) {
    if (step !== 1 || currentIndex !== 0) return null;
    if (APIFailure.isSlotsFailure || APIFailure.isTransactionFailure) {
      return OnlineBookingNotAvailable(true, APIFailure.isSlotsFailure || APIFailure.isTransactionFailure, windowSize, isSourcewellGovernment);
    }
    return <AppointmentDateAndTime setIsNextDisabled={setIsNextDisabled} setSlotDetails={setSlotDetails} />;
  }

  function renderStepThreeContent({ step, isJobDurationExceeds10Hrs, setIsNextDisabled, setSlotDetails }) {
    if (step !== 3) return null;
    if (isAssistanceRequired || isJobDurationExceeds10Hrs) {
      return <RequestOverviewOnVinCompatibilityIssue />;
    }
    return <AppointmentDateAndTime setIsNextDisabled={setIsNextDisabled} setSlotDetails={setSlotDetails} />;
  }

  function renderStepThreeRescheduleContent({ step, isScheduleApiFailed, jobDetails, dispatch, windowSize }) {
    if (step !== 3) return null;
    if (isScheduleApiFailed) {
      return (
        <RequestSubmitted
          isScheduleApiFailed={isScheduleApiFailed}
          caseId={jobDetails?.caseId}
          caseNumber={jobDetails?.caseNumber}
          handleClickLink={() => dispatch(resetAppointmentDetails())}
          windowSize={windowSize}
        />
      );
    }
    return <BookingConfirmed windowSize={windowSize} />;
  }

  function renderStepFourContent({
    step,
    isAssistanceRequired,
    agentAssistanceCaseDetails,
    isJobDurationExceeds10Hrs,
    caseSfdcId,
    caseNumber,
    dispatch,
    windowSize,
  }) {
    if (step !== 4) return null;
    if (isAssistanceRequired || isJobDurationExceeds10Hrs) {
      return (
        <RequestSubmitted
          isAssistanceRequired={isAssistanceRequired}
          isJobDurationExceeds10Hrs={isJobDurationExceeds10Hrs}
          caseId={isAssistanceRequired ? agentAssistanceCaseDetails.caseId : caseSfdcId}
          caseNumber={isAssistanceRequired ? agentAssistanceCaseDetails.caseNumber : caseNumber}
          handleClickLink={() => dispatch(resetAppointmentDetails())}
          windowSize={windowSize}
        />
      );
    }
    return <RequestOverview />;
  }

  function renderStepFiveContent({ step, isScheduleApiFailed, caseSfdcId, caseNumber, dispatch, windowSize }) {
    if (step !== 5) return null;
    if (isScheduleApiFailed) {
      return (
        <RequestSubmitted
          isScheduleApiFailed={isScheduleApiFailed}
          caseId={caseSfdcId}
          caseNumber={caseNumber}
          handleClickLink={() => dispatch(resetAppointmentDetails())}
          windowSize={windowSize}
        />
      );
    }
    return <BookingConfirmed windowSize={windowSize} />;
  }

  function getStepCurrent(step, currentStep) {
    return step === currentStep ? "step" : undefined;
  }

  function getStepLabel(step, currentStep, label) {
    if (step === currentStep) return `Step ${currentStep}, ${label}. Current step`;
    if (step > currentStep) return `${label} step completed`;
    return `Step ${currentStep}, ${label}`;
  }

  const { id: appointmentTitleId, text: appointmentTitleText } = getAppointmentTitle(isReschedule, jobDetails);
  const wrapperPaddingBottom = getWrapperPaddingBottom(windowSize);
  const rescheduleRowPadding = getRescheduleRowPadding(regionId);

  return (
    <ModalBox
      opened={props.isOpen}
      id="cp-modal"
      closeButton={
        <>
          <ModalHeaderCloseButton onClick={(event) => event.preventDefault()}>
            <CustomisedBackPath
              tabIndex="0"
              aria-label="Back"
              src={BackPath}
              id={getPendoId("header-backarrow-button")}
              onClick={handleFooterCancelValidate}
              onKeyDown={(e) => (e.key === "Enter" || e.keyCode === 32) && handleFooterCancelValidate()}
            />
            <CFSTCustomisedTitle>
              <h1 className="sr-only" tabIndex="-1" id={appointmentTitleId}>
                {appointmentTitleText}
              </h1>
              <Title size="large" aria-labelledby={appointmentTitleId} aria-hidden="true" tabIndex="-1">
                {appointmentTitleText}
              </Title>
            </CFSTCustomisedTitle>
          </ModalHeaderCloseButton>
          {<Line type="xLight" inverted={false} />}
        </>
      }
      fullScreenDialog={true}
      disableOutsideClick={true}
    >
      <CustomModalBody>
        <Loader active={loading} fullscreen={true} />
        {isApptAlreadyTaken && (
          <AppointmentTimeUnavailable
            isApptAlreadyTaken={isApptAlreadyTaken}
            setIsApptAlreadyTaken={setIsApptAlreadyTaken}
            decrementStep={decrementStep}
            setCurrentIndex={setCurrentIndex}
          />
        )}
        {isDiscardChange && <DiscardChangesModal handleDiscardChangeModal={handleDiscardChangeModal} />}
        {step === 2 && isCreateCaseAPIFailed && (
          <DeleteServiceModal reTriggerCreateCaseAPI={reTriggerCreateCaseAPI} isCreateCaseAPIFailed={isCreateCaseAPIFailed} />
        )}
        {isGoBackModalOpen && (
          <RedesignedModal
            opened={isGoBackModalOpen}
            onClickClose={() => setIsGoBackModalOpen(false)}
            zIndex={"1001"}
            isScrollable={false}
            title={"Go back?"}
            ModalAriaLabel="Go back modal"
            closeIconId={getPendoId("go-back-modal-close-icon-button")}
            button={
              <>
                <CustomisedTertiaryButton
                  id={getPendoId("go-back-modal-cancel-button")}
                  ariaLabel="Cancel"
                  tabIndex="0"
                  role="button"
                  size="large"
                  buttonWidth={windowSize.width < TABLET && "100%"}
                  marginTop={"0"}
                  onClick={() => setIsGoBackModalOpen(false)}
                >
                  {"CANCEL"}
                </CustomisedTertiaryButton>
                <CPButton
                  id={getPendoId("go-back-modal-go-back-button")}
                  ariaLabel="Go back"
                  tab-index="0"
                  role="button"
                  size="large"
                  secondary={false}
                  boxButton={true}
                  buttonHeight="40px"
                  buttonWidth={windowSize.width < TABLET && "100%"}
                  onClick={handleGoBack}
                >
                  {"GO BACK"}
                </CPButton>
              </>
            }
          >
            <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" lineHeight="20px" marginBottom="0" marginTop="0">
              Your selected date and time slot will not be saved.
            </TextWrapper>
          </RedesignedModal>
        )}
        {isReschedule ? (
          <>
            {accountDetails?.error ? (
              <div>
                <SomethingWentWrongTryAgain handleTryAgain={() => dispatch(fetchAccountDetails(account_id))} />
              </div>
            ) : (
              <div>
                <Wrapper paddingBottom={wrapperPaddingBottom}>
                  {!isJobScheduleDateIsWithInThreeBusinessDays && (
                    <CFSTFlexColumn id="full-screen-modal-cfst">
                      {step < 3 && (
                        <StepperWrapper id="customised-stepper" ref={stepperRef}>
                          <SubWrapper>
                            {/* Enabling the stepper count and its title for mobile view */}
                            {<StepperCount>Step {step} of 2</StepperCount>}
                            {step === 1 && <StepperTitle aria-label="Reschedule appointment">Reschedule appointment</StepperTitle>}
                            {step === 2 && <StepperTitle aria-label="Request overview">Request overview</StepperTitle>}
                            {/* Stepper is shown for all view and Step title is hidden for mobile view */}
                            <Stepper step={step - 1} animation={false}>
                              <Step>
                                <StepTitle aria-label="Reschedule appointment">Reschedule appointment</StepTitle>
                              </Step>
                              <Step>
                                <StepTitle aria-label="Request overview">Request overview</StepTitle>
                              </Step>
                            </Stepper>
                          </SubWrapper>
                        </StepperWrapper>
                      )}
                    </CFSTFlexColumn>
                  )}
                  <CFSTFlexRow paddingBottom={rescheduleRowPadding}>
                    {renderRescheduleStepOneContent({ step, currentIndex, APIFailure, windowSize, setIsNextDisabled, setSlotDetails })}
                    {step === 1 && currentIndex === 1 && <RescheduleReason setIsNextDisabled={setIsNextDisabled} />}
                    {step === 2 && <RequestOverview />}
                    {renderStepThreeRescheduleContent({ step, isScheduleApiFailed, jobDetails, dispatch, windowSize })}
                  </CFSTFlexRow>
                </Wrapper>
              </div>
            )}
          </>
        ) : (
          <div>
            <Wrapper paddingBottom={wrapperPaddingBottom}>
              {((!isAssistanceRequired && step < 5) || (isAssistanceRequired && step <= 3)) && !(isJobDurationExceeds10Hrs && step === 4) && (
                <CFSTFlexColumn id="full-screen-modal-cfst">
                  <StepperWrapper id="customised-stepper" ref={stepperRef} role="list">
                    {(isAssistanceRequired || isJobDurationExceeds10Hrs) && step <= 3 ? (
                      <SubWrapper>
                        {/* Enabling the stepper count and its title for mobile view */}
                        {<StepperCount>Step {step} of 3</StepperCount>}
                        {step === 1 && <StepperTitle aria-label="Vehicle or asset details">Vehicle or asset details</StepperTitle>}
                        {step === 2 && <StepperTitle aria-label="Contact details">Contact details</StepperTitle>}
                        {step === 3 && <StepperTitle aria-label="Request Overview"> Request Overview</StepperTitle>}
                        {/* Stepper is shown for all view and Step title is hidden for mobile view */}
                        <Stepper step={step - 1} animation={false}>
                          <Step>
                            <StepTitle aria-label="Vehicle or asset details" role="list-item" tabindex="0" aria-current={getStepCurrent(step, 1)}>
                              Vehicle or asset details
                            </StepTitle>
                          </Step>
                          <Step>
                            <StepTitle aria-label="Contact details" role="list-item" tabindex="0" aria-current={getStepCurrent(step, 2)}>
                              Contact details
                            </StepTitle>
                          </Step>
                          <Step>
                            <StepTitle aria-label="Request overview" role="list-item" tabindex="0" aria-current={getStepCurrent(step, 3)}>
                              Request Overview
                            </StepTitle>
                          </Step>
                        </Stepper>
                      </SubWrapper>
                    ) : (
                      step < 5 && (
                        <SubWrapper>
                          {/* Enabling the stepper count and its title for mobile view */}
                          {<StepperCount>Step {step} of 4</StepperCount>}
                          {step === 1 && <StepperTitle aria-label="Vehicle or asset details">Vehicle or asset details</StepperTitle>}
                          {step === 2 && <StepperTitle aria-label="Contact details">Contact details</StepperTitle>}
                          {step === 3 && <StepperTitle aria-label="Appointment time">Appointment time</StepperTitle>}
                          {step === 4 && <StepperTitle aria-label="Request overview">Request overview</StepperTitle>}
                          {/* Stepper is shown for all view and Step title is hidden for mobile view */}
                          <Stepper step={step - 1} animation={false}>
                            <Step>
                              <span className="sr-only" tabIndex="-1">
                                {getStepLabel(step, 1, "Vehicle or asset details")}
                              </span>
                              <StepTitle>
                                <span aria-hidden="true" tabIndex="-1">
                                  Vehicle or asset details
                                </span>
                              </StepTitle>
                            </Step>
                            <Step>
                              <span className="sr-only" tabIndex="-1">
                                {getStepLabel(step, 2, "Contact details")}
                              </span>
                              <StepTitle>
                                <span aria-hidden="true" tabIndex="-1">
                                  Contact details
                                </span>
                              </StepTitle>
                            </Step>
                            <Step>
                              <span className="sr-only" tabIndex="-1">
                                {getStepLabel(step, 3, "Appointment time")}
                              </span>
                              <StepTitle>
                                <span aria-hidden="true" tabIndex="-1">
                                  Appointment time
                                </span>
                              </StepTitle>
                            </Step>
                            <Step>
                              <span className="sr-only" tabIndex="-1">
                                {getStepLabel(step, 4, "Request overview")}
                              </span>
                              <StepTitle>
                                <span aria-hidden="true" tabIndex="-1">
                                  Request overview
                                </span>
                              </StepTitle>
                            </Step>
                          </Stepper>
                        </SubWrapper>
                      )
                    )}
                  </StepperWrapper>
                </CFSTFlexColumn>
              )}
              <CFSTFlexRow paddingBottom={rescheduleRowPadding}>
                {step === 1 && (
                  <VehicleAssetDetailsHeader
                    isAdditionalService={isAdditionalService}
                    setIsAdditionalService={setIsAdditionalService}
                    serviceId={serviceType}
                    setIsNextDisabled={setIsNextDisabled}
                    isNextDisabled={isNextDisabled}
                    stepperRef={stepperRef}
                    windowSize={windowSize}
                    jobId={jobResponseData?.id}
                    isAssistanceRequired={isAssistanceRequired}
                    setIsFirstServiceEdited={setIsFirstServiceEdited}
                  />
                )}
                {APIFailure.isJobFailure || APIFailure.isSlotsFailure || APIFailure.isTransactionFailure ? (
                  <>
                    {(step === 2 || step === 3) &&
                      OnlineBookingNotAvailable(
                        true,
                        APIFailure.isJobFailure || APIFailure.isSlotsFailure || APIFailure.isTransactionFailure,
                        windowSize,
                        isSourcewellGovernment
                      )}
                  </>
                ) : (
                  <>
                    {step === 2 && <ContactDetailsModal setIsNextDisabled={setIsNextDisabled} />}
                    {renderStepThreeContent({ step, isAssistanceRequired, isJobDurationExceeds10Hrs, setIsNextDisabled, setSlotDetails })}
                    {renderStepFourContent({
                      step,
                      isAssistanceRequired,
                      isJobDurationExceeds10Hrs,
                      agentAssistanceCaseDetails,
                      caseSfdcId,
                      caseNumber,
                      dispatch,
                      windowSize,
                    })}
                    {renderStepFiveContent({ step, isScheduleApiFailed, caseSfdcId, caseNumber, dispatch, windowSize })}
                  </>
                )}
              </CFSTFlexRow>
            </Wrapper>
          </div>
        )}
      </CustomModalBody>
      <Footer
        step={step}
        handleCancel={handleFooterCancel}
        handleStepNavigate={handleStepNavigate}
        isNextDisabled={isNextDisabled}
        handleFooterCancelValidate={handleFooterCancelValidate}
        windowSize={windowSize}
        regionId={regionId}
        isReschedule={isReschedule}
        currentIndex={currentIndex}
        isAssistanceRequired={isAssistanceRequired}
        isJobDurationExceeds10Hrs={isJobDurationExceeds10Hrs}
        isApiFailed={APIFailure.isJobFailure || APIFailure.isSlotsFailure || APIFailure.isTransactionFailure}
        isJobScheduleDateIsWithInThreeBusinessDays={isJobScheduleDateIsWithInThreeBusinessDays}
      />
    </ModalBox>
  );
};

const OnlineBookingNotAvailable = (cfstJobFailure, isJobFailed, windowSize, isSourcewellGovernment = false) => {
  let textWrapperWidth;
  if (windowSize.width >= TABLET) {
    textWrapperWidth = windowSize.width < 900 ? "71%" : "57%";
  } else {
    textWrapperWidth = "auto";
  }

  return (
    <EmptylistNotification title={"Online booking is not available right now"} genericError={cfstJobFailure} isJobFailed={isJobFailed}>
      <TextWrapper width={textWrapperWidth}>
        {isSourcewellGovernment ? (
          <>
            The information you have entered has been saved. We will contact you within two business days to book your appointment. Alternatively, you
            can call us on (800) 906-9545.
          </>
        ) : (
          <>
            The information you have entered has been saved. We will contact you within two business days to book your appointment. Alternatively, you
            can call us on (844) 617-1100, option 5.
          </>
        )}
      </TextWrapper>
    </EmptylistNotification>
  );
};

TechnicianAppointmentModal.propTypes = {
  serviceType: PropTypes.any,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export default TechnicianAppointmentModal;
